import { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../../context/GlobalContext'
import './CancelTransferRequest.scss'
import { Typography, Button, OTP } from 'mobily-ui-library/lib'
import { useTranslation } from 'react-i18next'
import SimIcon from '../../assets/SIM cards.svg'
import { orderInquiryApi } from '../../api/api'
import { cancelTransferRequest } from '../../api/api'

const CancelTransferRequest = () => {
  const { t } = useTranslation()
  const [state, dispatch]: any = useContext(GlobalContext)
  const { rtl } = state
  const dir = rtl ? 'right' : 'left'
  const { inquiryRes } = state
  const win: any = window
  var serverURL = win['base_portal_url']
  var errorPage = win['errorPageURL']

  const orderId = inquiryRes.orders[0].orderInfo.OrderNumber

  function ClickGoBackBtn() {
    dispatch({ type: 'GO_TO_SCREEN', payload: { page: 'OrderDetails' } })
  }
  const phoneNumber = ''
  const hashCode = ''

  function ClickCancelNumberTransferBtn() {
    console.log(orderId)
    cancelTransferRequest(orderId).then((response: any) => {
      if (response.status === 200) {
        console.log('inquiry data', response.data.status.statusCode)
        if (response.data.status.statusCode === '0000') {
          console.log('cancelled')
          cOrderApi(phoneNumber, orderId, hashCode)
        } else {
          // go to generic error
          window.location.href = serverURL + errorPage + `?errorSource= ${t('ecommerce')}`
        }
      } else {
        // go to generic error
        window.location.href = serverURL + errorPage + `?errorSource= ${t('ecommerce')}`
      }
    })
  }
  const cOrderApi = (phoneNumber: any, trackingNumber: any, hashCode: any) => {
    orderInquiryApi(phoneNumber, trackingNumber, hashCode).then((response: any) => {
      if (response.status === 200) {
        dispatch({ type: "LIST_OF_ORDERS_SUCCESS", payload: { selectedOrderDetails: response.data.orders } });

        console.log(orderId)
        dispatch({ type: 'GO_TO_SCREEN', payload: { page: 'OrderDetails' } })
      } else {
        // go to generic error
        window.location.href = serverURL + errorPage + `?errorSource= ${t('ecommerce')}`
      }
    })
  }
  return (
    <>
      <div className="the_all_page_cancel_transfer_request">
        <div className="CancelTransferRequest">
          <img className="theSimIcon" src={SimIcon} alt="mobilyIcon" />

          <Typography className="CancelTransferRequest_title">
            {t('sure_you_want_to_cancel_your_number_transfer_to_mobily')}
          </Typography>
          <div className="the_div_comment">
            <Typography className="the_comment">
              {t(
                'this_action_can’t_be_undone_You’ll_have_to_start_a_new_purchase_from_scratch_if_you_change_your_mind'
              )}
            </Typography>
          </div>

          <div className="CancelTransferRequest_Btn">
            <Button
              className="CancelRequest__modalBtn"
              primary={true}
              rtl={rtl}
              onClick={ClickCancelNumberTransferBtn}
            >
              {t('cancel_number_transfer')}
            </Button>

            <Button
              className="CancelRequest__modalBtn"
              primary={false}
              rtl={rtl}
              onClick={ClickGoBackBtn}
            >
              {t('go_back')}
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default CancelTransferRequest
